<template>
    <div class="club-step__wine-picker">
        <div class="club-step__wine-picker-list">
            <div class="club-step__wine-selection">
                <div class="club-step__wine-selection__title">
                    {{ title }}
                </div>
                <div class="club-step__wine-selection__meta">
                    <div class="club-step__wine-selection__count">
                        {{ count }} bottles
                    </div>
                    <div class="club-step__wine-selection__price" v-if="sellingPrice || originalPrice">
                        <span
                            class="club-step__wine-selection__price-before"
                            v-if="sellingPrice !== originalPrice"
                            >{{ originalPrice.toFixed(2) }}</span
                        >
                        <span class="club-step__wine-selection__price-after"
                            >${{ sellingPrice.toFixed(2) }}</span
                        >
                    </div>
                </div>
                <div class="club-step__wine-selection__list" v-if="wineList">
                    <WineCard
                        v-for="item in wineList"
                        :key="`catalog-wine-${item.ID}`"
                        :id="item.ID"
                        :quantity="item.Quantity"
                        :wine="item.Wine"
                    />
                </div>
                <div class="club-step__wine-selection__description">
                    {{ description }}
                </div>
                <div class="club-step__wine-selection__actions" v-if="actions">
                    <button
                        v-for="(action, index) in actions"
                        :key="`catalog-action-${index}`"
                        @click="action.method"
                        :class="action.className"
                    >
                        {{ action.title }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import WineCard from "./WineCard.vue";
export default {
    name: "WineCatalog",
    components: {
        WineCard,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
        },
        count: {
            type: Number,
            required: true,
        },
        sellingPrice: {
            type: Number,
        },
        originalPrice: {
            type: Number,
        },
        wineList: {
            type: Array,
        },
        actions: {
            type: Array,
        },
    },
    mounted() {
        // console.log('-----');
        // console.log(this.title);
        // console.log(this.wineList);
    },
};
</script>
